import
getAxiosInstance
  from '../../helpers/get_axios_instance'
import { debouncePromised } from '../../helpers/debounce'
import lrsAdapter from '../../helpers/lrs_adapter'

const debounceTimeout = 400

const autocompleteAdapter = (lrsData) => {
  const { data } = lrsData
  return {
    ...lrsData,
    data: data.map(e => e.valueAutocomplete)
  }
}

const lookup = (entity, value) => {
  if (String(value).length < 3 || value === null) return Promise.resolve([])

  const axios = getAxiosInstance()
  const promise = axios.get(`/${entity}_autocomplete?r=` +
    `{"clave":{"value_autocomplete":"${value}"}}`)

  return promise.then(lrsAdapter)
    .then(autocompleteAdapter)
    .then(response => response.data)
    .catch(_ => [])
}

const lookupSet = {}

export class Autocomplete {
  static search (entity, value) {
    if (!lookupSet[entity]) {
      lookupSet[entity] = debouncePromised(lookup, debounceTimeout)
    }
    const lookupFn = lookupSet[entity]
    return lookupFn(entity, value)
  }

  static directSearch (entity, value) {
    return lookup(entity, value)
  }

  static searchSet (set) {
    const promises = set.map(
      ({ entity, value }) => this.directSearch(entity, value))
    return Promise.all(promises)
  };

  static getEntityValues (entity, orderBy = null) {
    const axios = getAxiosInstance()
    const filtro = orderBy ? `?r={"orden": ["${orderBy}"]}` : ''
    const promise = axios.get(`${entity}_listado${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  };
};
